import { useToast } from '@chakra-ui/react'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useUser } from 'src/context/userContext'
import { useIamStore } from 'src/modules/iam/apis/store'
import { useQueryParams } from 'src/shared/hooks/useQueryParams'

export const useRedirectSSO = () => {
  const history = useHistory()
  const { getUser } = useUser()
  const toast = useToast()
  const { user, error, logout_uri } = useQueryParams<'user' | 'error' | 'logout_uri'>()
  const { saveToken, setUserEmail } = useIamStore((store) => ({
    saveToken: store.saveAccessToken,
    setUserEmail: store.setUserEmail,
  }))
  const errors = ['invalid_domain', 'email_not_found']
  const data: { email: string; accessToken: string } = user ? JSON.parse(atob(user)) : null
  const logoutUrl = logout_uri ? atob(logout_uri) : null

  useEffect(() => {
    if (data && data.accessToken) {
      saveToken(data.accessToken)
      setUserEmail(data.email)
      getUser()
      history.push('/home')
    }
  }, [])

  useEffect(() => {
    if (error) {
      toast({
        title: errors.includes(error)
          ? 'Email não encontrado'
          : 'Houve um erro ao realizar o seu login. Por favor tente novamente',
        isClosable: true,
        duration: 5000,
        status: 'error',
      })

      if (error === 'not_matching_email' && logoutUrl) {
        history.replace('/login')
        window.open(logoutUrl, '_blank')
      }
    }
  }, [error, logoutUrl])
}
